









































































































































import { Component, Vue } from 'vue-property-decorator';
import { orderList, getPartnerInfo, orderExport, exportDownload, queryMallList } from '../../utils/api';
import { codeToChangeString } from './public_mdule/orderRes';
import fuzzySearch from './common/fuzzySearch.vue';
import axios from 'axios';
import tableEmpty from '@/components/empty/tableEmpty.vue';
interface order {
  orderId: string;
  page: number;
  size: number;
  tenantId: string | null;
  orderBizType: string | null;
  purchaseId: string | null;
  supplierId: string | null;
  orderBizState: number | null;
  orderIdOrPoNo: string | null;
  sourceOrderId: string | null;
  consigneeName: string | null;
  partnerId: string | null;
  consigneePhone: string | null;
  mallCode: string | null;
}
interface search {
  stateNum: string | null;
  orderNum: string | null;
  peopleName: string | null;
  partnerId: string | null;
  consigneePhone: string | null;
  mallCode: string | null;
}
interface searchItem {
  value: string;
  code: string;
}

@Component({ components: { fuzzySearch, tableEmpty } })
export default class order_list_view extends Vue {
  currentPage = 1;
  pagesize = 10;
  totalElements = 0;
  dataList: any[] = [];
  activeName = '全部';
  // 搜索参数
  searchForm: search = {
    stateNum: null,
    orderNum: null,
    peopleName: null,
    consigneePhone: null,
    mallCode: null,
    partnerId: null,
  };
  loading = true;
  options1: any = []
  options2: any = []
  //初始化  请求体
  orderForm: order = {
    orderId: '',
    page: 0,
    size: this.pagesize,
    tenantId: null,
    orderBizType: null,
    purchaseId: null,
    supplierId: null,
    orderBizState: null,
    orderIdOrPoNo: null,
    sourceOrderId: null,
    consigneeName: null,
    partnerId: null,
    consigneePhone: null,
    mallCode: null
  };
  exportTimer = null;
  searchItem: searchItem = {
    value: '',
    code: '',
  };
  mounted() {
    this.getOrderList(this.orderForm);
    this.remoteMethods('');
  }
  // 收集模糊搜索商家名称
  fuzzySearchValue(item) {
    this.searchItem = item;
    this.searchForm.partnerId = item.code;
  }
  //订单导出
  async excelUpdata() {
    try {
      const { orderBizState, sourceOrderId, orderId, consigneeName, partnerId, consigneePhone, mallCode } = this.orderForm;
      const paramExport = {
        orderBizState,
        sourceOrderId,
        orderId,
        consigneeName,
        consigneePhone,
        mallCode,
        tenantId: partnerId,
      };
      const downKey = (await orderExport(paramExport))['key'];
      if (downKey) {
        this.getExport(downKey);
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
      this.$message.error(error.message);
    }
  }
  // 订单下载轮询
  getExport(downKey) {
    exportDownload({ key: downKey })
      .then((e) => {
        console.log(e);
        if (e.status == 3) {
          const down = document.createElement('a');
          down.href = e.url;
          down.id = 'downId';
          document.body.appendChild(down);
          (document.getElementById('downId') as any).click();
          down.remove();
          this.loading = false;
          this.$message({
            message: '导出成功',
            type: 'success',
          });
        } else if (e.status == 1) {
          // 实现轮询
          this.loading = true;
          this.exportTimer = setInterval(() => {
            this.getExport(downKey);
            clearInterval(this.exportTimer);
          }, 3000);
        } else {
          this.loading = false;
          this.$message({
            message: '导出数据失败',
            type: 'warning',
          });
        }
      })
      .catch((error) => {
        this.loading = false;
        console.error(error);
        this.$message.error(error);
      });
  }
  /*
   *@description:'获取订单列表'
   *@params1: orderForm post请求体
   */
  async getOrderList(orderForm) {
    try {
      this.loading = true;
      // 改变当前页
      this.currentPage = orderForm.page + 1;
      const result = await orderList(orderForm);
      this.dataList = result['content'];
      this.totalElements = result['totalElements'];
      //数据处理 解决假报错
      for (const key in this.dataList) {
        if (!this.dataList[key]) {
          this.dataList[key] = 'undefind';
        }
      }
      //支付状态Code转名称 支付状态-动态style
      this.dataList = this.dataList.map((item) => {
        codeToChangeString(item);
        if (item.amount) {
          // var str = item.amount.indexOf('.')
          // var t = item.amount.slice(0,str)
          // console.log(t)
          item.amount = item.amount;
        }
        if (item.realAmount) {
          item.realAmount = item.realAmount;
        }
        if (item.orderSkuAmount) {
          item.orderSkuAmount = item.orderSkuAmount;
        }
        return item;
      });
      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log(error);
      this.$message.error(error.message);
    }
  }
  /*
   *@description:'表单重置函数封装'
   *@ReturnValue:'orderForm重置后'
   */
  ressetForm() {
    const orderForm: order = {
      orderId: '',
      page: 0,
      size: this.pagesize,
      tenantId: null,
      orderBizType: null,
      purchaseId: null,
      supplierId: null,
      orderBizState: null,
      orderIdOrPoNo: null,
      sourceOrderId: null,
      consigneeName: null,
      partnerId: null,
      consigneePhone: null,
      mallCode: null
    };
    return orderForm;
  }
  /*
   *@description:'重置按钮，重新请求列表'
   */
  async resetSearch() {
    try {
      // 重置模糊搜索输入框
      Object.assign((this as any).$data.searchItem, (this as any).$options.data['call'](this).searchItem);
      this.searchForm = {
        stateNum: null,
        orderNum: null,
        peopleName: null,
        consigneePhone: null,
        mallCode: null,
        partnerId: null,
      };
      queryMallList().then(res => {
        this.loading = false;
        this.options1 = res;
      });
      this.options2 = []
      this.searchForm.mallCode = ''
      await this.getOrderList(this.ressetForm());
      this.activeName = '全部';
      this.orderForm = this.ressetForm();
      // 清楚导出轮询的定时器
      clearInterval(this.exportTimer);
    } catch (error) {
      console.log(error);
      this.$message.error(error.message);
    }
  }
  //输入限制只可输入数字
  textInputChange(val) {
    this.searchForm.consigneePhone = val.replace(/[^\d]/g, '');
  }
  /*
   *@description:'搜索按钮'
   */
  async handlerSearch() {
    try {
      // 收集输入框内容
      // if (this.searchForm.stateNum) {

      // }
      this.orderForm.sourceOrderId = this.searchForm.stateNum;
      this.orderForm.orderId = this.searchForm.orderNum;
      this.orderForm.consigneeName = this.searchForm.peopleName;
      this.orderForm.consigneePhone = this.searchForm.consigneePhone;
      this.orderForm.mallCode = this.searchForm.mallCode;
      this.orderForm.partnerId = this.searchForm.partnerId;
      // if (this.searchForm.orderNum) {

      // }
      // if (this.searchForm.peopleName) {

      // }
      // if (this.searchForm.consigneePhone) {
      // }
      // if (this.searchForm.partnerId) {
      // }
      // 查询分页默认回到第一页
      this.orderForm.page = 0;
      //重新请求
      await this.getOrderList(this.orderForm);
      //根据search结果动态改变tabs状态
      if (this.dataList.length == 1) {
        // this.activeName = this.dataList[0].bizState;
      } else if (this.dataList.length <= 0) {
        // 没有数据
        // this.$message.warning('暂无数据');
      } else {
        const flag = this.dataList[0].bizState;
        const result = this.dataList.every((item) => {
          return item.bizState == this.dataList[0].bizState;
        });
        if (result) {
          this.activeName = this.dataList[0].bizState;
        } else {
          this.activeName = '全部';
        }
      }
    } catch (error) {
      console.log(error);
      this.$message.error(error.message);
    }
  }
  /*
   *@description:'点击tabs切换'
   *@params1: tab.index 点击的对应下班
   *@params2: event 点击事件
   */
  // 订单业务状态;10：待支付，20：待发货，25：部分发货，30：已发货，99：已完成，0：交易关闭，11：取消订单申请中
  async handleClick1(tab, event) {
    try {
      // let orderForm = this.ressetForm();
      this.orderForm.sourceOrderId = this.searchForm.stateNum;
      this.orderForm.orderId = this.searchForm.orderNum;
      this.orderForm.consigneeName = this.searchForm.peopleName;
      this.orderForm.consigneePhone = this.searchForm.consigneePhone;
      this.orderForm.mallCode = this.searchForm.mallCode;
      this.orderForm.partnerId = this.searchForm.partnerId;
      // if (this.searchForm.stateNum) {

      // }
      // if (this.searchForm.orderNum) {

      // }
      // if (this.searchForm.peopleName) {

      // }
      // if (this.searchForm.consigneePhone) {

      // }
      // if (this.searchForm.partnerId) {

      // }
      if (tab.index == 1) {
        this.orderForm.orderBizState = 10;
      }
      //  else if (tab.index == 2) {
      //   this.orderForm.orderBizState = 25;
      // }
      else if (tab.index == 2) {
        this.orderForm.orderBizState = 20;
      } else if (tab.index == 3) {
        this.orderForm.orderBizState = 30;
      } else if (tab.index == 4) {
        this.orderForm.orderBizState = 99;
      } else if (tab.index == 5) {
        this.orderForm.orderBizState = 0;
      } else if (tab.index == 0) {
        this.orderForm.orderBizState = null;
      }
      await this.getOrderList(this.orderForm);
    } catch (error) {
      console.log(error);
      this.$message.error(error.message);
    }
  }
  /*
   *@description:'跳转详情页'
   *@params1: row 当前点击的这一项
   */
  handleClick2(row) {
    // 1532782394166964279
    this.$router.push(`detailed?orderId=${row.orderId}`);
    // console.log(row);
  }
  /*
   *@description:'分页'
   *@params1: data.currentPageNow 当前页 data.displayDataNow当前的数据条数
   */
  async handleCurrentChange(val) {
    try {
      this.orderForm.page = val - 1;
      await this.getOrderList(this.orderForm);
    } catch (error) {}
  }

  //渠道商城搜索
  remoteMethods(query) {
    query = query.trim()
    if (query !== '') {
      this.options2 = this.options1.filter(item => {
        return item.name.indexOf(query) > -1;
      });
    } else {
      queryMallList().then(res => {
        this.loading = false;
        this.options1 = res;
      });
      this.searchForm.mallCode = ''
      this.options2 = []
    }
  }
}
